/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import MultipleButtonsItems from './MultipleButtonsItems';


const LineupIsOnNow = ({
  handlerSetComponents, components, id, reusableComponent, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'LineupIsOnNow',
    event: '',
    venueSlugName: '',
    isLight: false,
    isClickable: true,
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandler = (e) => {
    const { value, name } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: value,
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const toggleHandler = (e, bool) => {
    const { name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: bool,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <div className="w-full px-4 bg-greyFilter rounded-lg flex flex-col">
      <div className="w-full px-5 rounded-lg flex pt-4 pb-4 ml-6">
        <label htmlFor="event" className="flex flex-col font-americaMonoRegular text-xs uppercase text-black w-1/2 mx-1 mt-1 xxl1:w-1/2">
          Event
          <input className="mt-1 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="event" type="text" value={state.event} readOnly={reusableComponent && reusableComponent} />
        </label>
        <label htmlFor="event" className="flex flex-col font-americaMonoRegular text-xs uppercase text-black w-1/2 mx-1 mt-1 xxl1:w-1/2">
          Venue SlugName
          <input className="mt-1 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="venueSlugName" type="text" value={state.venueSlugName} readOnly={reusableComponent && reusableComponent} />
        </label>
      </div>
      <div className="w-full px-5 rounded-lg flex pt-4 pb-4 ml-6">
        <div className="text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center whitespace-pre pl-3">
          is light?
          <label className="switch mb-0 pb-0 h-6 ml-1">
            <input
              className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm"
              name="isLight"
              checked={!state.isLight}
              onChange={e => toggleHandler(e, !state.isLight)}
              type="checkbox"
              id="switch-button"
            />
            <div className="switch-slider btn-yn switch-round" />
          </label>
        </div>
        <div className="text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center whitespace-pre pl-3">
          is text clickable?
          <label className="switch mb-0 pb-0 h-6 ml-1">
            <input
              className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm"
              name="isClickable"
              checked={!state.isClickable}
              onChange={e => toggleHandler(e, !state.isClickable)}
              type="checkbox"
              id="switch-button"
            />
            <div className="switch-slider btn-yn switch-round" />
          </label>
        </div>
      </div>
    </div>
  );
};

LineupIsOnNow.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
LineupIsOnNow.defaultProps = {
  reusableComponent: null,
};

export default LineupIsOnNow;
